import { styled } from "styled-components";

export const MyInfoTitleEdit = styled.div`
  font-size: 12px;
  font-weight: 600;
  color: #383838;

  width: 100px;
`;
